import { AppShell, PageTitle } from "@/components/app-shell";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MilestoneSkeleton } from "@/components/mission-skeletons";
import { useProjectScope } from "@/lib/project-scope";
import { missionStageHref, trackPane } from "@/lib/workflow";
import { useLocation, useNavigate } from "react-router-dom";

export function MilestonesPage() {
  return (
    <AppShell title={<PageTitle kicker="06 Track · shared across workstreams">Milestones / Releases</PageTitle>}>
      <MilestonesBody />
    </AppShell>
  );
}

function MilestonesBody() {
  const { milestones, projectBase, loading } = useProjectScope();
  const location = useLocation();
  const nav = useNavigate();
  const pane = trackPane(location.pathname) ?? "ms";
  const base = projectBase || "";

  return (
    <Tabs
      value={pane}
      onValueChange={(next) => {
        nav(missionStageHref(base, next === "rel" ? "releases" : "milestones"));
      }}
    >
      <TabsList>
        <TabsTrigger value="ms">Milestones</TabsTrigger>
        <TabsTrigger value="rel">Releases</TabsTrigger>
      </TabsList>
      <TabsContent value="ms" className="mt-4">
        {loading ? (
          <MilestoneSkeleton />
        ) : (
          <>
        {milestones.length === 0 && (
          <p className="mb-4 text-sm text-muted-foreground">No milestones in this project.</p>
        )}
        <div className="grid gap-3 md:grid-cols-3">
          {milestones.map((m) => (
            <Card key={m.id}>
              <CardHeader>
                <CardTitle className="flex items-center gap-2 text-sm">
                  {m.name} <Badge variant="secondary">{m.status}</Badge>
                </CardTitle>
              </CardHeader>
              <CardContent className="text-xs text-muted-foreground">
                Target {m.target_date ?? "—"} · links reqs / HW rev / issues
              </CardContent>
            </Card>
          ))}
        </div>
          </>
        )}
      </TabsContent>
      <TabsContent value="rel" className="mt-4 text-sm text-muted-foreground">
        No releases yet. Tag after a review lands.
      </TabsContent>
    </Tabs>
  );
}
